import axios from 'axios';

// Configured instance that sends the httpOnly auth cookies (see
// somo-circle1-api Issue #302) on every request/response - required for
// cross-origin cookie auth to work. Call sites that need the auth cookie
// must import `api` and use it explicitly, rather than relying on a global
// axios.defaults mutation: with a global default, a file that forgets to
// import this module drops credentials silently (no console error - the
// cookie just never gets set, and login appears to "hang").
export const api = axios.create({ withCredentials: true });
